import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'ttag';

import OutletLogo from '@svg/outlet-logo.svg';
import MenuIcon from '@svg/menu.svg';
import { Link } from '@ui/Link';
import { Button } from '@ui/Button';
import { Skeleton } from '@ui/Skeleton';
import { HeaderSearchContainer, RootCatalog } from '@containers/HeaderSearch';
import { LanguageToggle } from '@components/LanguageToggle';
import { HeaderAuthLinks } from '@components/HeaderAuthLinks';
import { FastLink, HeaderFastLinks } from '@components/HeaderFastLinks';
import { HeaderUserMenu, UserMenuLink } from '@components/HeaderUserMenu';

import s from './HeaderDesktop.sss';

interface User {
  id: number,
  username: string,
  avatar?: string | null,
  unreadMessagesCount: number,
  hasUnreadNotifications?: boolean | null,
  isSeller: boolean,
}

interface Props {
  className?: string,
  catalogName?: string,
  rootCatalogs?: RootCatalog[],
  user?: User | null,
  fastLinks: FastLink[],
  userMenuLinks: UserMenuLink[],
  isUserLoading?: boolean,
  onMenuToggle: () => void,
}

export const HeaderDesktop: React.FC<Props> = ({
  className,
  catalogName,
  rootCatalogs,
  user,
  fastLinks,
  userMenuLinks,
  isUserLoading,
  onMenuToggle,
}) => {
  const location = useLocation();

  return (
    <div className={classNames(s.root, className)}>
      <section className={s.logoSection}>
        <Link
          className={s.logoLink}
          to='/'
        >
          <OutletLogo
            className={s.logo}
            width="159"
            height="48"
          />
        </Link>
      </section>

      <section className={s.searchSection}>
        <Button
          theme='secondary'
          className={s.menuButton}
          onClick={(e) => {
            e.stopPropagation();
            onMenuToggle();
          }}
        >
          <MenuIcon
            className={s.menuIcon}
            width='16'
            height='14'
          />
          {catalogName || t`Каталог`}
        </Button>

        <div className={s.search}>
          <HeaderSearchContainer
            rootCatalogs={rootCatalogs}
          />
        </div>
      </section>

      <LanguageToggle
        className={s.languageToggle}
        pathname={location.pathname}
      />

      <section className={s.userSection}>
        {!!user ? (
          <>
            <HeaderFastLinks fastLinks={fastLinks} />
            <HeaderUserMenu
              user={user}
              links={userMenuLinks}
            />
          </>
        ) : (
          <>
            {isUserLoading ? (
              <Skeleton
                type='circle'
                width='40px'
                height='40px'
              />
            ) : (
              <HeaderAuthLinks />
            )}
          </>
        )}
      </section>
    </div>
  );
};
